// extracted by mini-css-extract-plugin
export default {"form":"SetPasswordModal_form__jjWs2","input":"SetPasswordModal_input__u5S1J","formItem":"SetPasswordModal_formItem__b8mpl"};